import React from 'react';
import "./common.scss";

function CommonInput({ id, disabled, type, value, onChange, placeholder, name, className, maxLength, style }) {
    return (
        <div className='common_input'>
            <input
                id={id}
                type={type}
                value={value}
                name={name}
                placeholder={placeholder}
                className={className}
                maxLength={maxLength}
                disabled={disabled}
                onChange={(e) => onChange(e)}
                style={style}
            />
        </div>
    );
}

export default CommonInput